module.exports = __webpack_public_path__ + "static/flags/AG-a0327c71af41a42aef762bf3bcfeab63.gif";